import { __assign } from '../../../tslib/tslib.es6.mjs';
import * as React from 'react';
import { RemoveScroll } from './UI.js';
import SideCar from './sidecar.js';

var ReactRemoveScroll = React.forwardRef(function (props, ref) { return (React.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: SideCar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;

export { ReactRemoveScroll as default };
